import React from "react";
import { Helmet } from "react-helmet";
const BlockchainHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>
        Block Chain & NFT Portfolio | Digious Solutions
      </title>
      <meta
        name="description"
        content="Browse Digious Solutions’ NFT and blockchain portfolio featuring creative Web3 designs, digital assets, and innovative decentralized solutions."
      />
    </Helmet>
  );
};

export default BlockchainHelmet;
